import React, { useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { Button, MenuItem, TextField, Box } from '@mui/material'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { ApiCreateAddOnQuestionData, ApiPostBriefJson } from '../../../apiService/Core/Apicall.tsx'

const AddNewAddOnQuestion: React.FC = () => {
  const [formValues] = useState({
    AddOnQuestion: '',
    AddonQuestionType: ''
  })

  const handleSubmit = async (values: any, { resetForm }: any) => {
    try {
      const payload = {
        addOnQuestionText: values.AddOnQuestion,
        addOnQuestionType: values.AddonQuestionType,
      }

      const response = await ApiCreateAddOnQuestionData(payload)
      toast.success(response.message)
      resetForm()
    } catch (error) {
      toast.error('Failed to add Add On Question')
      console.error(error)
    }
  }

  return (
    <Box className='p-2 w-100'>
    <Formik
      initialValues={formValues}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({ handleChange, handleBlur, values }) => (
        <Form className='add-update-form bg-white border-10 p-2 py-3'>
          <h1 className='common-add'>Add New Add On Question</h1>
          <div className='Form-BriefJson'>
            <Box flexDirection={{xs:"column",md:"row"}} className='BriefJson-flex'>
              <label htmlFor='AddOnQuestion' className='BriefJson-Label form-label'>
                Add On Question:
              </label>
              <TextField
                // as={TextField}
                id='AddOnQuestion'
                name='AddOnQuestion'
                variant='outlined'
                size='small'
                value={values.AddOnQuestion}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
              />
              <ErrorMessage name='AddOnQuestion' component='div' className='error' />
            </Box>
            <Box flexDirection={{xs:"column", md:"row"}} className='BriefJson-flex'>
              <label htmlFor='AddonQuestionType' className='BriefJson-Label form-label'>
                Add On Question Type:
              </label>
              <Field
                as={TextField}
                select
                id='AddonQuestionType'
                name='AddonQuestionType'
                variant='outlined'
                size='small'
                value={values.AddonQuestionType}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
              >
                <MenuItem value='text'>Text</MenuItem>
                <MenuItem value='time'>Time</MenuItem>
                <MenuItem value='longtext'>Long Text</MenuItem>
              </Field>
              <ErrorMessage name='AddonQuestionType' component='div' className='error' />
            </Box>
          </div>

          <div className='text-center'>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              className='table-row-background add-update-button'
            >
              Add Add On Question
            </Button>
          </div>
        </Form>
      )}
    </Formik>
    </Box>
  )
}

export default AddNewAddOnQuestion;
